import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { mergeShineAccounts, ProductResponse } from '../query-api'

interface UseMergeShineAccountsProps {
  onError?: (error: APIError) => void
  onSuccess?: () => void
}

export interface ShineConnectionMergeParams {
  organizationId: string
  targetProduct: ProductResponse
  sourceProduct: ProductResponse
  signature: string
}

export const useMergeShineAccounts = (props?: UseMergeShineAccountsProps) => {
  const { onError, onSuccess } = props || {}
  const {
    mutate: update,
    isLoading: isProcessing,
    ...rest
  } = useMutation(
    ({ organizationId, targetProduct, sourceProduct, signature }: ShineConnectionMergeParams) =>
      mergeShineAccounts({ organizationId, payload: { targetProduct, sourceProduct, signature } }),
    {
      onSuccess,
      onError,
    },
  )

  return {
    isProcessing,
    update,
    ...rest,
  }
}
